import { render } from "./index.vue?vue&type=template&id=6495ba58"
import script from "./grid-table.ts?vue&type=script&lang=js"
export * from "./grid-table.ts?vue&type=script&lang=js"

import "./grid-table.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script